import { createFileRoute } from "@tanstack/react-router";
import { MyBookingsPage } from "@/routes/_user/bookings";

export const Route = createFileRoute("/admin/my-bookings")({ component: MyBookingsPage });
